import { markdownWithoutSteps } from './stepGroups';
import { markdownWithoutTabs } from './tabBlocks';

export function createHeadingId(text = '') {
  return text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .trim()
    .replace(/\s+/g, '-');
}

export function cleanHeadingText(text = '') {
  return text
    .replace(/\*\*/g, '')
    .replace(/\*/g, '')
    .replace(/__/g, '')
    .replace(/_/g, '')
    .replace(/`/g, '')
    .trim();
}

// Steps shown as a carousel (utils/stepGroups.js) and the contents of tabs
// (utils/tabBlocks.js) are not listed: only one of them is on screen at a
// time, so their headings would be dead links.
export function extractHeadings(markdown = '') {
  const headingIdCounts = new Map();

  return markdownWithoutSteps(markdownWithoutTabs(markdown))
    .split(/\r?\n/)
    .map((line) => {
      const match = line.match(
        /^\s*(#{2,4})\s+(.+?)\s*#*\s*$/,
      );

      if (!match) {
        return null;
      }

      const level = match[1].length;
      const text = cleanHeadingText(match[2]);

      if (!text) {
        return null;
      }

      const baseId = createHeadingId(text);
      const currentCount =
        headingIdCounts.get(baseId) ?? 0;

      headingIdCounts.set(
        baseId,
        currentCount + 1,
      );

      return {
        level,
        text,
        id:
          currentCount === 0
            ? baseId
            : `${baseId}-${currentCount + 1}`,
      };
    })
    .filter(Boolean);
}

export function getHeadingText(children) {
  if (
    typeof children === 'string' ||
    typeof children === 'number'
  ) {
    return String(children);
  }

  if (Array.isArray(children)) {
    return children
      .map(getHeadingText)
      .join('');
  }

  if (children?.props?.children) {
    return getHeadingText(
      children.props.children,
    );
  }

  return '';
}
